var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down_Arrow_-_Big",
    "data-name": "Down Arrow - Big",
    d: "M5.392,1.93a1.427,1.427,0,0,1,2.449,0l4.629,8.49a1.263,1.263,0,0,1-1.224,1.816H1.987A1.263,1.263,0,0,1,.763,10.42Z",
    transform: "translate(12.617 12.236) rotate(180)",
    fill: "#ec3818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigDownArrow);
export default __webpack_public_path__ + "static/media/big-down-arrow.c7ce075f9b38026d19c4c77a79006c1a.svg";
export { ForwardRef as ReactComponent };